<!-- NO trigger button here; parent opens via #modal.open() -->
<div class="modal-content" [class.shadow-none]="false">
  <div class="modal-header align-items-start">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ 'userProfile.edit.title' | translate }}</h2>
      <p class="text-muted small mb-0">{{ 'userProfile.edit.requiredFieldsPrefix' | translate }} <span class="text-danger">*</span> {{ 'userProfile.edit.requiredFieldsSuffix' | translate }}</p>
    </div>
  </div>
  <div class="modal-body">
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="('userProfile.edit.firstName' | translate) + ' *'"
          [placeholder]="'userProfile.edit.firstName' | translate"
          [type]="'text'"
          [(value)]="user.first_name"
          [invalid]="isFirstNameInvalid"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="('userProfile.edit.lastName' | translate) + ' *'"
          [placeholder]="'userProfile.edit.lastName' | translate"
          [type]="'text'"
          [(value)]="user.last_name"
          [invalid]="isLastNameInvalid"
        />
      </div>
    </div>
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="('userProfile.edit.email' | translate) + ' *'"
          [placeholder]="'userProfile.edit.email' | translate"
          [type]="'email'"
          [(value)]="user.email"
          [invalid]="isEmailInvalid"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'userProfile.edit.phone' | translate"
          [placeholder]="'userProfile.edit.phone' | translate"
          [type]="'tel'"
          [(value)]="user.phone"
        />
      </div>
    </div>
    <div class="row g-4 spacing-30">
      <div class="col-lg-6 col-6">
        <app-input-component
          [label]="'userProfile.edit.dateOfBirth' | translate"
          [placeholder]="'userProfile.edit.dateOfBirth' | translate"
          [type]="'date'"
          [(value)]="user.date_of_birth"
        />
      </div>
      <div class="col-lg-6 col-6">
        <app-input-component
          [label]="'userProfile.edit.ridingClub' | translate"
          [placeholder]="'userProfile.edit.ridingClub' | translate"
          [type]="'text'"
          [(value)]="user.riding_club"
        />
      </div>
    </div>
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-selectorini
          [options]="countries"
          [displayKey]="'name'"
          [valueKey]="'country_id'"
          [(value)]="user.country_id"
          [label]="'userProfile.edit.country' | translate"
          [placeholder]="'userProfile.edit.countryPlaceholder' | translate"
          [searchable]="true"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'userProfile.edit.address' | translate"
          [placeholder]="'userProfile.edit.address' | translate"
          [type]="'text'"
          [(value)]="user.address"
        />
      </div>
    </div>
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'userProfile.edit.state' | translate"
          [placeholder]="'userProfile.edit.state' | translate"
          [type]="'text'"
          [(value)]="user.state"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'userProfile.edit.city' | translate"
          [placeholder]="'userProfile.edit.city' | translate"
          [type]="'text'"
          [(value)]="user.city"
        />
      </div>
    </div>
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'userProfile.edit.postalCode' | translate"
          [placeholder]="'userProfile.edit.postalCode' | translate"
          [type]="'number'"
          [(value)]="user.zip_code"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <app-fileorini
          [accept]="'image/*'"
          (filesChanged)="profileImage = $event[0]"
        />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <app-button
      [label]="saving ? ('userProfile.edit.saving' | translate) : ('userProfile.edit.save' | translate)"
      [iconClass]="saving ? 'fa fa-spinner fa-spin' : ''"
      [variant]="'primary'"
      [disabled]="saving"
      (clicked)="saveProfile()"
    />
  </div>
</div>

